export default function max(num1: number, num2: number) {
  if (num1 > num2) return num1;
  return num2;
}
